function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { InputControl } from 'components/InputControl/InputControl';
const TextInput = /*#__PURE__*/React.forwardRef(({
  value,
  onChange,
  maxLength,
  defaultValue = '',
  ...props
}, ref) => {
  const [internalValue, setInternalValue] = useState(value ?? defaultValue);
  const handleChange = e => {
    if (onChange) {
      onChange(e);
    }
    setInternalValue(e.target.value);
  };
  return /*#__PURE__*/React.createElement(InputControl, _extends({
    ref: ref,
    type: "text",
    value: value ?? internalValue,
    onChange: handleChange,
    maxLength: maxLength,
    currentLength: internalValue.toString().length
  }, props));
});
export { TextInput };